import './User.css';
import { Avatar } from '../../../Avatar/Avatar';

const userName = 'peshaman';
const teamName = 'Team 878787';

export const User = () => {
    return (
        <div className="header__user">
            <div className="header__user-avatar-container">
                <Avatar />
            </div>
            <div className="header__user-text-container">
                <span className="header__user-text">{userName}</span>
                <span className="header__user-text">{teamName.toUpperCase()}</span>
            </div>
        </div>
    );
};
